module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Illustrations"
    }
  }, [_c('p', {
    staticClass: "ilu-title"
  }, [_vm._v("Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Introduction#ufig_viii"
    }
  }, [_vm._v("Engelbert Endrass and Erich Topp")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter01#ufig_11"
    }
  }, [_vm._v("Erich Topp, Engelbert Endrass and friends at a Paris nightclub")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter01#ufig_12"
    }
  }, [_vm._v("Engelbert Endrass and guests in his French villa")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter01#ufig_13"
    }
  }, [_vm._v("Karl-Friedrich Merten")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02#ufig_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KL Karl-Friedrich Merten aboard the "), _c('i', [_vm._v("Schleswig-Holstein")])])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02#map_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ultra intercept of a German radio signal from U-111")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02#map_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Merten’s chart for the sinking of the "), _c('i', [_vm._v("Darkdale")])])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02#map_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Merten’s chart for the sinking of the "), _c('i', [_vm._v("Bradford City")])])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02#map_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ultra intercept of Admiral Dönitz’s signal to Merten")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02#ufig_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Merten on the bridge of U-68")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02#ufig_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Midshipman Ralph Kapitsky")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter03#ufig_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ralph Kapitsky and U-615’s officers")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter03#ufig_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U-615 returning from her first patrol to the North Atlantic")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter03#ufig_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fritz Guggenberger relaxing after a patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter04#ufig_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U-28, on which Guggenberger sewed as a watch officer")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter04#ufig_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U-81’s hit on the British carrier "), _c('i', [_vm._v("Ark Royal")])])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter04#ufig_69_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crewmen of U-8 1 celebrate the sinking of "), _c('i', [_vm._v("Ark Royal")])])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter04#ufig_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adolf Hitler bestows the Oak Leaves cluster upon Guggenberger")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter04#ufig_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guggenberger and his Knight’s Cross with Oak Leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter04#ufig_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U-516 on patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter04#ufig_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Victor Oehrn returning from his first patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter05#ufig_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grand Admiral Karl Donitz")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter05#ufig_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Victor Oehrn in January 1944, after his release from British captivity")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter05#ufig_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heinz-Wilhelm Eck while a cadet with Crew 34")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter06#ufig_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The commissioning of U-852, June 15, 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "ill-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter06#ufig_114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U-852 beached on the East African coast")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5824080d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Illustrations.vue
// module id = 69
// module chunks = 0